import Controller from '@ember/controller';

export default class AuthenticatedNetworkMonitorController extends Controller {}
